import { Observable } from 'rxjs';

let supportsIntersectionObserver = false;

if (typeof window !== 'undefined') {
  supportsIntersectionObserver = 'IntersectionObserver' in window;
}

export function inView(
  element: HTMLElement,
  options: IntersectionObserverInit = {
    root: null,
    threshold: 0.3
  }
): Observable<boolean> {
  return new Observable<boolean>(subscriber => {
    if (!supportsIntersectionObserver) {
      subscriber.next(true);
      subscriber.complete();
      
      return;
    }

    const observer = new IntersectionObserver(entries => {
      // Several changes may occur in the same tick, we want to check the latest entry state.
      const entry = entries[entries.length - 1];

      subscriber.next(entry.isIntersecting);
    }, options);

    subscriber.add(() => {
      observer.unobserve(element);
      observer.disconnect();
    });

    observer.observe(element);
  });
}